import { Box, Dialog, styled, Typography } from "@mui/material";
import PrimaryButton from "../PrimaryButton";
import GetInTouchImage from "../../assets/icons/icon_getintouch.svg";

const GetTeamSupportModal = (props) => {
  const { handleModalClose, isFrom = "signup", showModal } = props;

  return (
    <Dialog open={showModal} onClose={handleModalClose}>
      <DialogContentContainer>
        <img src={GetInTouchImage} alt="Get in Touch" width="100%" />
        <Typography component="h3" variant="h4" color="text.white" my={3}>
          Get in touch with <br /> the <HiglightedText>REBLIE</HiglightedText>{" "}
          Support Team.
        </Typography>
        <Typography mb={2} color="text.white">
          {isFrom === "signup"
            ? `Thank you for your interest in Reblie. Our support team is ready to assist you with your custom requirements.`
            : `Your request for a plan upgrade has been submitted to the admin directly.`}
        </Typography>
        <Typography color="text.white">
          Contact us: P: 903-991-3811 | E: contact@reblie.com
        </Typography>
        <ButtonContainer>
          <PrimaryButton
            variant="outlined"
            color="primary"
            onClick={handleModalClose}
          >
            Okay, got it
          </PrimaryButton>
        </ButtonContainer>
      </DialogContentContainer>
    </Dialog>
  );
};

const DialogContentContainer = styled(Box)(({ theme }) => ({
  padding: "16px 24px",
  background: theme.palette.background.dark,
  maxWidth: "450px",
  border: "1px solid #707070",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "32px 0px 16px",
}));

const HiglightedText = styled("b")(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export default GetTeamSupportModal;
